import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Checkbox.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "label",
    {
      ref: "checkbox",
      staticClass: "checkbox-wrapper",
      attrs: { for: _vm.id, tabindex: "-1", disabled: _vm.disabled }
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.isChecked,
            expression: "isChecked"
          }
        ],
        ref: "input",
        attrs: {
          id: _vm.id,
          type: "checkbox",
          "is-invalid": _vm.isInvalid,
          disabled: _vm.disabled
        },
        domProps: {
          value: _vm.value,
          checked: Array.isArray(_vm.isChecked)
            ? _vm._i(_vm.isChecked, _vm.value) > -1
            : _vm.isChecked
        },
        on: {
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          change: function($event) {
            var $$a = _vm.isChecked,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;
            if (Array.isArray($$a)) {
              var $$v = _vm.value,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.isChecked = $$a.concat([$$v]));
              } else {
                $$i > -1 &&
                  (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
              }
            } else {
              _vm.isChecked = $$c;
            }
          }
        }
      }),
      _vm._v(" "),
      !_vm.indeterminate
        ? _c("CheckboxIcon", { staticClass: "icon" })
        : _c("CheckboxIndeterminateIcon", { staticClass: "indeterminate" }),
      _vm._v(" "),
      _vm.$slots["default"]
        ? _c("span", { staticClass: "input-label" }, [_vm._t("default")], 2)
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-0d647a23";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Checkbox/Checkbox.vue.js